import React from 'react';

const SuccessScreen = () => {
  return <div></div>;
};

export default SuccessScreen;
